import React, { Component } from 'react'
import {
  withFirebase,
  firebaseConnect} from 'react-redux-firebase'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { styles } from './dockPadStyle'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import MaterialTable, { MTableToolbar } from 'material-table'
import moment, { Moment } from 'moment'
import IconButton from '@material-ui/core/IconButton'
import Divider from '@material-ui/core/Divider'
import EditIcon from '@material-ui/icons/Edit'
import { getProjectId, isProjectLoaded } from '../selectors/project.selector'
import { getDailyTag, getDailyReports, getHuddleDate, lookaheadTagFBConnect, getSelectedLookaheadId, getLookaheadTrades, getHuddleFilter } from '../selectors/lookahead.selector'
import { ThunkDispatch } from 'redux-thunk'
import { LookaheadTag, LookaheadTagStatus } from '../models/LookaheadTag'
import { Chip, Select, MenuItem, AppBar, Toolbar, Avatar } from '@material-ui/core'
import { Trade } from '../models/Trade'
import fontColorContrast from 'font-color-contrast';
import { lookaheadActions } from '../actions/lookahead.actions'
import { ClassNameMap } from '@material-ui/core/styles/withStyles'
import LookaheadTagDialogContainer from '../components/Dialogs/LookaheadTagDialogContainer'
import { withGetScreen } from 'react-getscreen'
import { HuddleFilter } from '../modules/lookahead.reducer'
import { TagType } from '../models/ TagType'
import ButtonBase from '@material-ui/core/ButtonBase';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TodayIcon from '@material-ui/icons/Today';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ReportViewDialog from '../components/Dialogs/ReportViewDialog'

const _ = require('lodash');

const SmallAvatar = withStyles((theme) => ({
  root: {
    width: 64,
    height: 64
  },
}))(Avatar)

interface Props {
  dailyTags: LookaheadTag[],
  trades: Record<string, Trade>,
  classes: ClassNameMap,
  openLookaheadDialog: (tagId?:string) => void;
  isMobile: () => boolean;
  isTablet: () => boolean;
  huddleFilter: HuddleFilter;
  huddleFilterChange: (filter: HuddleFilter) => void;
  changeStatus: (tagId:string, tagType:TagType, status:LookaheadTag) => void;
  isProjectLoaded: boolean;
  openLookaheadModal: (tagId: string) => void,
  huddleDateUp: () => void;
  huddleDateDown: () => void;
  huddleDate: Moment;
  dailyReports: Record<string, any>
  openReportDialog: (tradeId?:string, reportDate?:string) => void
}

type State = {
 tableFilter: string
}


class DailyHuddleScreen extends Component<Props, State> {

  state = {
    tableFilter: 'tags'
  }

  renderTrade = (tag: LookaheadTag) => {
    if(!tag.tradeId) {
      return
    }

    const trade = this.props.trades[tag.tradeId] as Trade

    if(!trade) {
      return
    }

    const tradeColor = trade.color

    return <Chip label={trade.name} style={{backgroundColor: tradeColor, color: fontColorContrast(tradeColor)  }} />
  }

  renderEdit(rowData:LookaheadTag) {
    const { openLookaheadDialog, classes } = this.props;
    return (
        <IconButton
            onClick={() => {
              openLookaheadDialog(rowData.uid);
            }}>
            <EditIcon
            className={classNames(classes.AllTasksScreenVisibilityIcon)}
            />
        </IconButton>
    )
  }

  renderReportEdit = (rowData:LookaheadTag) => {
    const { openReportDialog, classes, huddleDate } = this.props;
    return (
        <IconButton
            onClick={() => {
              openReportDialog(rowData.tradeId, huddleDate.format('MM-DD-YYYY'));
            }}>
            <VisibilityIcon
              className={classNames(classes.AllTasksScreenVisibilityIcon)}
            />
        </IconButton>
    )
  }

  renderStatus = (rowData: LookaheadTag) => {

    return <Chip label={!!LookaheadTagStatus[rowData.status] ? rowData.status : LookaheadTagStatus.Todo} style={{ }} />
  }

  renderConstraintsCount = (rowData) => {
    const constraints = !!rowData.constraints ? rowData.constraints : {}

    return `Constraints (+${Object.keys(constraints).length})`
  }

  renderDeliveryCount = (rowData) => {
    const constraints = !!rowData.deliveries ? rowData.deliveries : {}

    return `Delivery (+${Object.keys(constraints).length})`
  }

  renderTaskCount = (rowData) => {
    const constraints = !!rowData.tasks ? rowData.tasks : {}

    return `Task (+${Object.keys(constraints).length})`
  }


  renderQuestionCount = (rowData) => {
    const constraints = !!rowData.questions? rowData.questions : {}

    return `Delivery (+${Object.keys(constraints).length})`
  }


  renderReportsTable = () => {
    const { classes, dailyReports } = this.props
    const { tableFilter } = this.state

    if(tableFilter != 'reports') {
      return
    }

    const reports = Object.keys(!!dailyReports ? dailyReports : {}).map(tradeId => {
      const report = dailyReports[tradeId]
      report['tradeId'] = tradeId

      return report
    })
    return (
      <MaterialTable
        className={classNames(classes.AllTasksScreenStyle)}
        components={{
          Toolbar: props => (
            <div className={classNames(classes.AllTasksScreenTableHeader)}>
              <MTableToolbar {...props} />
            </div>
          )
        }}
        columns={[
          {
            title: '',
            field: 'edit',
            render: rowData => {
              return this.renderReportEdit(rowData)
            },
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px'
            },
            headerStyle: {
               padding: '4px'
           }
          },
          {
            title: 'Trade',
            field: 'trade',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            },
            render: rowData => {
              return this.renderTrade(rowData)
            }
          },
          {
            title: 'Crew Size',
            field: 'crewSize',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            }
          },
          {
            title: 'Location',
            field: 'location',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            }
          },
          {
            title: 'Constraints',
            field: 'location',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            },
            render: rowData => {
              return this.renderConstraintsCount(rowData)
            }
          },
          {
            title: 'Deliveries',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            },
            render: rowData => {
              return this.renderDeliveryCount(rowData)
            }
          },
          {
            title: 'Tasks',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            },
            render: rowData => {
              return this.renderTaskCount(rowData)
            }
          },
          {
            title: 'Questions',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            },
            render: rowData => {
              return this.renderQuestionCount(rowData)
            }
          }

        ]}
        data={reports}
        title=""
        options={{
          pageSize: 4,
          maxBodyHeight: 300
        }}
      />
    );
  }

  renderUpcomingTable = () => {
    const { classes } = this.props
    const { tableFilter } = this.state

    if(tableFilter != 'tags') {
      return
    }
    return (
      <MaterialTable
        className={classNames(classes.AllTasksScreenStyle)}
        components={{
          Toolbar: props => (
            <div className={classNames(classes.AllTasksScreenTableHeader)}>
              <MTableToolbar {...props} />
            </div>
          )
        }}
        columns={[
          {
            title: '',
            field: 'edit',
            render: rowData => {
              return this.renderEdit(rowData)
            },
            cellStyle: {
              backgroundColor: '#f9fcfd',
              padding: '4px'
            },
            headerStyle: {
               padding: '4px'
           }
          },
          {
            title: 'Trade',
            field: 'trade',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            },
            render: rowData => {
              return this.renderTrade(rowData)
            }
          },
          {
            title: 'Name',
            field: 'name',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            }
          },
          {
            title: 'Crew Size',
            field: 'crewSize',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            }
          },
          {
            title: 'Location',
            field: 'locationId',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            }
          },
          {
            title: 'Status',
            cellStyle: {
              backgroundColor: '#f9fcfd'
            },
            render: rowData => {
              return this.renderStatus(rowData)
            }
          }
        ]}
        data={this.props.dailyTags}
        title=""
        options={{
          pageSize: 4,
          maxBodyHeight: 300
        }}
      />
    );
  }

  shouldComponentUpdate(nextProps:Props, nextState:State) {
    if(_.isEqual(this.props.dailyTags, nextProps.dailyTags)) {
      return true
    }

    if(this.props.huddleDate != nextProps.huddleDate) {
      return true
    }

    return false
  }

  getIncompleteTagsCount = () => {
    return this.props.dailyTags.filter(tag => (!tag.status || !LookaheadTagStatus[tag.status] || tag.status === LookaheadTagStatus.Todo || tag.status === LookaheadTagStatus.WorkingOn)).length
  }

  getDoneTagsCount = () => {
    return this.props.dailyTags.filter(tag => (tag.status === LookaheadTagStatus.Done)).length

  }

  getReportCount = () => {
    return !!this.props.dailyReports ? Object.keys(this.props.dailyReports).length : 0
  }

  renderDesktop = () => {

    const { classes, isMobile, isTablet } = this.props;

    if(isMobile() || isTablet()) {
      return
    }

    return (
      <React.Fragment>
        <Divider style={{marginTop: 32}} />
        <ul className={classNames(classes.topBanner)}>
            <li className={classNames(classes.topBannerLI)} key={0}>
              <div className={classNames(classes.topBannerTitle)}>Incomplete Tags</div>
              <div className={classNames(classes.topBannerMetric)}><p>{this.getIncompleteTagsCount()}</p></div>
            </li>
            <li className={classNames(classes.topBannerLI)} key={1}>
              <div className={classNames(classes.topBannerTitle)}>Complete Tags</div>
              <div className={classNames(classes.topBannerMetric)}><p>{this.getDoneTagsCount()}</p></div>
            </li>
            <li className={classNames(classes.topBannerLI)} key={2}>
              <div className={classNames(classes.topBannerTitle)}>Reports</div>
              <div className={classNames(classes.topBannerMetric)}><p>{this.getReportCount()}</p></div>
            </li>
        </ul>

        <Divider />
        {this.renderChooseMenu()}
        {this.renderUpcomingTable()}
        {this. renderReportsTable()}
      </React.Fragment>
    )
  }

  onReportFilterClicked = () => {
    this.setState({
      tableFilter: 'reports'
    })
  }

  onTagFilterClicked = () => {
    this.setState({
      tableFilter: 'tags'
    })
  }

  renderChooseMenu = () => {
    const { classes } = this.props

    const tagCount = this.props.dailyTags.length
    const reportCount = this.getReportCount()
    
    return (
      <div style={{display: 'flex', marginTop: 32, marginBottom: 32}}>
        <div onClick={this.onTagFilterClicked} style={{marginRight: 32, cursor: "pointer"}}>
          <p className={classNames(classes.huddleButtons, {[classes.huddleButtonOff]:  this.state.tableFilter != 'tags'}, {[classes.huddleButtonOn]:  this.state.tableFilter == 'tags'})}>Total {tagCount} Tags</p>
          <div className={classNames({[classes.huddleButtonUnderlineOff]:  this.state.tableFilter != 'tags'}, {[classes.huddleButtonUnderlineOn]:  this.state.tableFilter == 'tags'})}/>
        </div>
        <div style={{cursor: "pointer"}}>

          <p onClick={this.onReportFilterClicked} className={classNames(classes.huddleButtons, {[classes.huddleButtonOff]:  this.state.tableFilter != 'reports'}, {[classes.huddleButtonOn]:  this.state.tableFilter == 'reports'})}>Total {reportCount} Reports</p>
          <div className={classNames({[classes.huddleButtonUnderlineOff]:  this.state.tableFilter != 'reports'}, {[classes.huddleButtonUnderlineOn]:  this.state.tableFilter == 'reports'})}/>

        </div>
      </div>
    )
  }

  renderTradeAvatar = (tag:LookaheadTag) => {
    if(!tag.tradeId) {
      return
    }

    const trade = this.props.trades[tag.tradeId] as Trade

    if(!trade) {
      return
    }

    const tradeColor = trade.color
    const fontColor = fontColorContrast(tradeColor)
    return <SmallAvatar style={{color: fontColor, backgroundColor: tradeColor}}>{trade.name.substring(0,2)}</SmallAvatar>
  }

  renderMobileListContent = (tag: LookaheadTag) => {
    return (
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '16px'}}>
        <span>{tag.name}</span>
        <span>{tag.locationId}</span>
      </div>
    )
  }

  renderMobileListStatus = (tag: LookaheadTag) => {
    return (
      <div>
        <Select
            onClick={(e) => {
              e.preventDefault() 
              e.stopPropagation()
            }} 
            onChange={this.handleTagStatusChange(tag)}
            value={!!LookaheadTagStatus[tag.status] ? tag.status : LookaheadTagStatus.Todo}>
          {this.renderTagStatusMenu()}
        </Select>
      </div>
    )
  }

  onRowClick = (tag: LookaheadTag) => {
    const { openLookaheadModal } = this.props
    return (e:any) => {
      openLookaheadModal(tag.uid)
    }
  }

  renderMobileTagList = () => {
    const { dailyTags, classes } = this.props
    return dailyTags.map(tag => {
      return (
        <ButtonBase onClick={this.onRowClick(tag)}>
          <div className={classes.TagMobileListItem}>
              <div style={{display: 'flex', alignItems: 'center', marginLeft: '16px'}}>
                {this.renderTradeAvatar(tag)}
                {this.renderMobileListContent(tag)}
              </div>

            <div style={{display: 'flex', height:'100%', alignItems: 'center', justifyContent: 'center', marginRight: '16px'}}>
              {this.renderMobileListStatus(tag)}
            </div>
          </div>
        </ButtonBase>

      )
    })
  }

  renderMobile = () => {
    const { classes, isMobile, isTablet } = this.props;
    if(!isMobile() && !isTablet()) {
      return
    }

    return (
      <React.Fragment>
        {this.renderMobileTagList()}
      </React.Fragment>
    )
  }

  renderTagStatusMenu = () => {
    return Object.entries(LookaheadTagStatus).map(([key, value]) => {
      return (
        <MenuItem value={key}>{value}</MenuItem>
      )
    })
  }
  renderHuddleMenu = () => {
    return Object.entries(HuddleFilter).map(([key, value]) => {
      return (
        <MenuItem value={key}>{value}</MenuItem>
      )
    })
  }

  handleTagStatusChange = (tag: LookaheadTag) => {
    return (event: any) => {
      const { changeStatus } = this.props
      //huddleFilterChange(event.target.value)
      changeStatus(tag.uid, tag.tagCardType, event.target.value)
    }
  }

  handleFilterDateChange = (event:any) => {
    const { huddleFilterChange } = this.props
    huddleFilterChange(event.target.value)
  }

  renderDesktopTopBar = () => {
    const { classes, huddleFilter, isMobile, huddleDate } = this.props;
    if(isMobile()) {
      return
    }

    return (
      <div className={classNames(classes.overviewHeader)}>
        <Typography
          style={{fontSize: '22px', fontWeight: 500}}
          className={classNames(classes.sectionPaperHeader)}
          noWrap >
          Huddle
        </Typography>
        <div style={{flexDirection: 'row', display: 'flex', alignItems: 'center'}}>
          <div style={{border: '2px solid #C6DAF5', borderRadius: 16,paddingLeft: 12, paddingRight: 12, paddingTop: 6, paddingBottom: 6}}>
            <Typography style={{margin: 0, fontSize: 12, fontWeight: 400}}>
              <TodayIcon style={{height: 14, width: 14, marginRight: 4}} />
              {huddleDate.format('l')}
            </Typography>
          </div>

          <div style={{display: 'flex', alignItems: 'center'}}>
            <IconButton onClick={this.props.huddleDateDown} style={{height: 14, width: 14, marginRight: 4}}  >
              <ChevronLeftIcon style={{height: 14, width: 14}} />
            </IconButton>
            <div style={{height: 6, width: 6, backgroundColor: '#000', borderRadius: '50%'}}></div>
            <IconButton onClick={this.props.huddleDateUp}  style={{height: 14, width: 14, marginLeft: 4}} >
              <ChevronRightIcon style={{height: 14, width: 14}} />
            </IconButton>
          </div>
        </div>
      </div>
    )
  }

  renderMobileTopBar = () => {
    const { classes, isMobile, isTablet, huddleFilter } = this.props
    if(!isMobile() && !isTablet()) {
      return
    }

    return (
      <AppBar style={{width: '100vw', marginLeft: '-24px'}} position="static">
        <Toolbar>
          <Typography style={{color: '#fff', flexGrow: 1, fontSize: '22px', fontWeight: 500}} className={classes.title} variant="h6" noWrap>
            Huddle
          </Typography>
          <Select
            className={classNames(classes.whiteSelect)}
            color="inherit"
            style={{  }}
            onChange={this.handleFilterDateChange}
            value={huddleFilter}
          >
            {this.renderHuddleMenu()}
          </Select>
        </Toolbar>
      </AppBar>
    )
  }

  renderContent = () => {
    return(
      <React.Fragment>
        {this.renderDesktop()}
        {this.renderMobile()}
      </React.Fragment>
    )
  }

  renderTopBar = () => {
    return (
      <React.Fragment>
        {this.renderDesktopTopBar()}
        {this.renderMobileTopBar()}
      </React.Fragment>
    )
  }

  render() {
    const { classes, isProjectLoaded } = this.props;

    if(!isProjectLoaded) {
      return (
        <React.Fragment>

        </React.Fragment>
      )
    }

    return (
      <div style={{marginRight: '16px'}} className={classNames(classes.pageContainer)}>
				<LookaheadTagDialogContainer />
				<ReportViewDialog/>

        {this.renderTopBar()}
        {this.renderContent()}


      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  dailyTags: getDailyTag(state),
  trades: getLookaheadTrades(state),
  huddleFilter: getHuddleFilter(state),
  huddleDate: getHuddleDate(state),
  isProjectLoaded: isProjectLoaded(state),
});

const mapStateToPropsReports = (state:any) => ({
  dailyReports: getDailyReports(state)
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

  return {
    openLookaheadDialog: (tagId?: string) => dispatch(lookaheadActions.lookaheadDialogOpen(tagId)),
    openReportDialog: (tradeId?:string, reportDate?: string) => dispatch(lookaheadActions.openReportDialog(tradeId, reportDate)),
    huddleFilterChange: (huddleFiler: HuddleFilter) => dispatch(lookaheadActions.huddleFilterChange(huddleFiler)),
    huddleDateUp: () => dispatch(lookaheadActions.huddleFilterUp()),
    huddleDateDown: () => dispatch(lookaheadActions.huddleFilterDown()),

    changeStatus: (tagId:string, tagType:TagType, status:LookaheadTagStatus) => dispatch(lookaheadActions.changeLookaheadTagStatus(tagId, tagType, status)),
    openLookaheadModal: (tagId: string) => dispatch(lookaheadActions.lookaheadDialogOpen(tagId))
  }
};

export default compose(
  withRouter,
  withFirebase,
  withGetScreen,
  connect(state => {
    return {
        projectId: getProjectId(state),
        lookaheadId: getSelectedLookaheadId(state),
      }
  }),
  firebaseConnect(lookaheadTagFBConnect),
  connect(mapStateToProps, mapDispatchToProps),
  firebaseConnect((props:any) => {
    if(!props.projectId || !props.huddleDate) {
      return
    } 

    const formmatedHuddleDate = props.huddleDate.isValid() ? props.huddleDate.format('MM-DD-YYYY') : moment().format('MM-DD-YYYY')
    return [
      {
          path: `/dailyReport/projects/${props.projectId}/date/${formmatedHuddleDate}/trade`,
          storeAs: 'SELECTED_DAILYREPORTS'
      }
  ]
  }),

  connect(mapStateToPropsReports, null),


  withStyles(styles, { withTheme: true })
)(DailyHuddleScreen)



// WEBPACK FOOTER //
// ./src/containers/DailyHuddleScreen.tsx